export default __webpack_public_path__ + "static/media/head-red.b349497e.png";